module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5e8eccd5a576638f029a1ed2deb4784b.svg";